module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/$.add-to-unscopables.js
// module id = 233
// module chunks = 0